<div class="col-xl employee-detail-wrap" *ngIf="isCreateMode || employee">
    <div class="employee-breadcrumb mb-3">
        <a [routerLink]="['/employee/list']">Listado de colaboradores</a> / <span class="current">{{isCreateMode ? 'Registrar colaborador' : 'Detalles del colaborador'}}</span>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <div class="d-flex align-items-center gap-3">
            <button type="button" class="employee-back-btn" (click)="goBack()" title="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <div class="employee-avatar">
                <ng-container *ngIf="!isCreateMode; else createAvatar">
                    <img *ngIf="photoUrl" [src]="photoUrl" alt="Foto del colaborador">
                    <span *ngIf="!photoUrl">{{initials}}</span>
                </ng-container>
                <ng-template #createAvatar><span>NC</span></ng-template>
            </div>
            <div *ngIf="!isCreateMode">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <h4 class="mb-0 employee-name">{{fullName}}</h4>
                    <span class="employee-status-badge" [class.is-active]="statusIsActive" [class.is-inactive]="!statusIsActive">
                        <span class="dot"></span>{{statusLabel}}
                    </span>
                </div>
                <p class="employee-subtitle mb-0">
                    {{employee.position?.name || 'Sin puesto'}} &nbsp;|&nbsp; {{employee.department?.name || 'Sin departamento'}} &nbsp;|&nbsp; Ingreso: {{formatDate(employee.hire_date)}}
                </p>
            </div>
            <div *ngIf="isCreateMode">
                <h4 class="mb-0 employee-name">Nuevo colaborador</h4>
            </div>
        </div>
        <button type="button" class="employee-payroll-btn" *ngIf="!isCreateMode" (click)="onPayrollClick()">
            <img src="assets/img/icons/icon-folder-shared.svg" alt=""> Nómina del colaborador
        </button>
    </div>

    <ul class="nav employee-main-tabs">
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="mainTab === 'datos'" (click)="setMainTab('datos')">
                <img class="main-tab-icon" src="assets/img/icons/main-tab-datos-colaborador.svg" alt="">
                <span>Datos del colaborador</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="mainTab === 'historico'"
                [class.is-disabled]="isMainTabDisabled('historico')" [disabled]="isMainTabDisabled('historico')"
                (click)="setMainTab('historico')">
                <img class="main-tab-icon" src="assets/img/icons/main-tab-historico.svg" alt="">
                <span>Histórico del colaborador</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="mainTab === 'salarios'"
                [class.is-disabled]="isMainTabDisabled('salarios')" [disabled]="isMainTabDisabled('salarios')"
                (click)="setMainTab('salarios')">
                <img class="main-tab-icon" src="assets/img/icons/main-tab-historial-salarios.svg" alt="">
                <span>Historial de salarios</span>
            </button>
        </li>
        <li class="nav-item flex-fill">
            <button type="button" class="nav-link w-100" [class.active]="mainTab === 'infonavit'"
                [class.is-disabled]="isMainTabDisabled('infonavit')" [disabled]="isMainTabDisabled('infonavit')"
                (click)="setMainTab('infonavit')">
                <img class="main-tab-icon main-tab-icon-wide" src="assets/img/icons/main-tab-infonavit.svg" alt="">
                <span>Crédito INFONAVIT</span>
            </button>
        </li>
    </ul>

    <div class="employee-main-panel">
        <ng-container *ngIf="mainTab === 'datos'">
            <ul class="nav employee-sub-tabs mb-4">
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'general'" (click)="setSubTab('general')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/tab-datos-generales.svg" alt=""></span>
                        <span>Datos generales</span>
                    </button>
                </li>
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'salario'"
                        [class.is-disabled]="isSubTabDisabled('salario')" [disabled]="isSubTabDisabled('salario')"
                        (click)="setSubTab('salario')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/tab-salario.svg" alt=""></span>
                        <span>Salario</span>
                    </button>
                </li>
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'personal'"
                        [class.is-disabled]="isSubTabDisabled('personal')" [disabled]="isSubTabDisabled('personal')"
                        (click)="setSubTab('personal')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/tab-datos-personales.svg" alt=""></span>
                        <span>Datos personales</span>
                    </button>
                </li>
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'salud'"
                        [class.is-disabled]="isSubTabDisabled('salud')" [disabled]="isSubTabDisabled('salud')"
                        (click)="setSubTab('salud')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/tab-salud.svg" alt=""></span>
                        <span>Salud</span>
                    </button>
                </li>
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'fiscales'"
                        [class.is-disabled]="isSubTabDisabled('fiscales')" [disabled]="isSubTabDisabled('fiscales')"
                        (click)="setSubTab('fiscales')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/tab-fiscales.svg" alt=""></span>
                        <span>Fiscales</span>
                    </button>
                </li>
                <li class="sub-tab-item">
                    <button type="button" class="sub-tab-link" [class.active]="subTab === 'imss'"
                        [class.is-disabled]="isSubTabDisabled('imss')" [disabled]="isSubTabDisabled('imss')"
                        (click)="setSubTab('imss')">
                        <span class="sub-tab-icon-badge"><img src="assets/img/icons/imss-tooth.svg" alt=""></span>
                        <span>IMSS</span>
                    </button>
                </li>
            </ul>

            <app-general-data-tab *ngIf="subTab === 'general'" [employee]="employee" [mode]="isCreateMode ? 'create' : 'edit'" (saved)="onEmployeeUpdated($event)"></app-general-data-tab>
            <app-salary-tab *ngIf="subTab === 'salario'" [employee]="employee" (saved)="onEmployeeUpdated($event)"></app-salary-tab>
            <app-personal-data-tab *ngIf="subTab === 'personal'" [employee]="employee" (saved)="onEmployeeUpdated($event)"></app-personal-data-tab>
            <app-health-tab *ngIf="subTab === 'salud'" [employee]="employee" (saved)="onEmployeeUpdated($event)"></app-health-tab>
            <app-fiscal-tab *ngIf="subTab === 'fiscales'" [employee]="employee" (saved)="onEmployeeUpdated($event)"></app-fiscal-tab>
            <app-imss-tab *ngIf="subTab === 'imss'" [employee]="employee" (saved)="onEmployeeUpdated($event)" (goToFiscal)="setSubTab('fiscales')"></app-imss-tab>
        </ng-container>

        <app-history-tab *ngIf="mainTab === 'historico'" [employee]="employee"></app-history-tab>
        <app-salary-history-tab *ngIf="mainTab === 'salarios'" [employee]="employee" variant="dashboard"></app-salary-history-tab>
        <app-infonavit-credit-tab *ngIf="mainTab === 'infonavit'" [employee]="employee"></app-infonavit-credit-tab>
    </div>
</div>

<div class="col-xl" *ngIf="!isCreateMode && !employee">
    <div class="card">
        <div class="card-body text-center py-5 text-muted">Cargando información del colaborador...</div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
